<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepDecision.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepDecision.BODY')"></p>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="selected < 3" @click.native="$emit('continue')">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-xl>
      <v-card>
        <v-layout wrap>
          <v-card-title>
            <v-flex v-for="(item,n) in recommendations" :key="n" xs12 md6>
              <v-card hover @click.native="toggleSelectRecommendation(item)" v-bind:class="{'light-green': isSelected(item)}">
                <v-card-title>
                  <span style="float: left;" v-show="false">{{ item.scope + '.' + item.itemOrder }}</span>
                  <span class="subheading" style="margin-left: auto; margin-right: 0;" v-t="{path: 'info.scopes.SCOPE'+item.scope+'.TITLE', locale: questionnaire.version}"></span>
                </v-card-title>
                <v-card-title class="title" v-t="{path: 'ITEM'+item.id+'.TITLE', locale: questionnaire.version}">
                </v-card-title>
                <v-card-title>
              <span style="float: left;">
                <v-icon color="deep-purple lighten-4" v-if="item.complexity == 1">radio_button_checked</v-icon>
                <v-icon color="deep-purple lighten-4" v-else>radio_button_unchecked</v-icon>
                <v-icon color="deep-purple lighten-1" v-if="item.complexity == 2">radio_button_checked</v-icon>
                <v-icon color="deep-purple lighten-1" v-else>radio_button_unchecked</v-icon>
                <v-icon color="deep-purple darken-4" v-if="item.complexity == 3">radio_button_checked</v-icon>
                <v-icon color="deep-purple darken-4" v-else>radio_button_unchecked</v-icon>
              </span>
                  <span class="subheading" style="margin-left: auto; margin-right: 0; cursor: pointer">
                <v-icon v-on:click="showHelp(item.id)">help_outline</v-icon>
              </span>
                </v-card-title>
                <v-card-title class="body-1" style="display: none;" v-bind:id="'exp' + item.id">
                  <span v-t="{path: 'ITEM'+item.id+'.ITEM_EXPLANATION', locale: questionnaire.version}"></span>
                </v-card-title>
              </v-card>
              <v-btn class="mt-0" color="primary" block v-on:click="showIncorporate(item.id)">
                <span class="caption" v-t="{path: 'info.incorporateDialog.BUTTON', locale: questionnaire.version}"></span>
                <v-icon light small right>live_help</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>

        </v-layout>

      </v-card>
    </v-container>
  </div>
</template>
<style>
  button .btn__content {
    white-space: inherit;
    flex: inherit;
  }
</style>
<script>
  export default {
    name: 'tutorial-step-decision',
    data () {
      return {
        recommendations: [
          {id: 6, scope: 1, complexity: 1},
          {id: 12, scope: 2, complexity: 2},
          {id: 15, scope: 3, complexity: 1},
          {id: 23, scope: 4, complexity: 1},
          {id: 30, scope: 5, complexity: 1},
          {id: 24, scope: 5, complexity: 3}
        ],
        questionnaire: {
          version: this.$auth.user().version
        },
        recommendationSelected: [],
        saved: false,
        selected: 0
      }
    },
    methods: {
      toggleSelectRecommendation: function (item) {
        if (!this.saved) {
          if (this.isSelected(item)) {
            --this.selected
            var index = this.recommendationSelected.indexOf(item.id)
            if (index > -1) {
              this.recommendationSelected.splice(index, 1)
            }
          } else {
            if (this.selected < 3) {
              ++this.selected
              this.recommendationSelected.push(item.id)
            }
          }
        }
      },
      isSelected: function (item) {
        for (var recommendation in this.recommendationSelected) {
          if (this.recommendationSelected[recommendation] === item.id) return true
        }
        return false
      },
      showIncorporate: function (itemId) {
        this.incorporateKey = itemId
        this.incorporateHelp = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStepDecision.vue